import styled from "styled-components"

export const Sku = styled.div`
  margin: 0.5rem 0 2rem 0;

  :last-of-type {
    margin-bottom: 0;
  }
`
